// apps/web/src/App.tsx
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { checkHealthForMaintenance } from "./features/onboarding/api/onboardingApi";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        const result = await checkHealthForMaintenance({ timeoutMs: 5000 });
        if (!alive) return;

        const pathname = location.pathname;

        if (result === "maintenance" && pathname !== "/maintenance") {
          navigate("/maintenance", { replace: true });
          return;
        }

        if (result === "ok" && pathname === "/maintenance") {
          navigate("/", { replace: true });
          return;
        }
      } finally {
        if (alive) setChecking(false);
      }
    };

    void run();

    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 0, md: 6 },
        background: "linear-gradient(90deg, #6CCB8B 0%, #3975D0 100%)",
        position: "relative",
      }}
    >
      {checking ? (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 2,
          }}
        >
          {/* Glass card */}
          <Box
            sx={{
              width: "100%",
              maxWidth: 520,
              borderRadius: { xs: 4, md: 6 },
              px: { xs: 3, sm: 5 },
              py: { xs: 3.5, sm: 4 },

              backgroundColor: "rgba(255,255,255,0.88)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              border: "1px solid rgba(255,255,255,0.7)",
              boxShadow: "0 20px 60px rgba(15, 23, 42, 0.18)",

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 1.75,
            }}
          >
            <CircularProgress thickness={4} sx={{ color: "#6CCB8B" }} />

            <Typography
              sx={{
                color: "#0A0A0A",
                fontWeight: 800,
                fontSize: { xs: "1.1rem", sm: "1.2rem" },
                lineHeight: 1.2,
                letterSpacing: "-0.01em",
              }}
            >
              {t(
                "onboarding.app.preparing.title",
                "Solo un attimo, stiamo preparando tutto"
              )}
            </Typography>

            <Typography
              sx={{
                color: "#4A5568",
                fontSize: { xs: "0.95rem", sm: "1rem" },
                lineHeight: 1.55,
                maxWidth: 440,
              }}
            >
              {t(
                "onboarding.app.preparing.subtitle",
                "Potrebbero volerci alcuni secondi."
              )}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Outlet />
      )}
    </Box>
  );
}
